import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { App } from '@capacitor/app';
import { Browser } from '@capacitor/browser';

@Injectable()
export class MobileDocumentService {

  private readonly WORD_PLAY_STORE_URL =
    'https://play.google.com/store/apps/details?id=com.microsoft.office.word';

  private readonly WORD_APP_STORE_URL =
    'https://apps.apple.com/app/microsoft-word/id586447913';

  private readonly FALLBACK_DELAY = 2000;
  private readonly APP_SWITCH_THRESHOLD = 3000;

  constructor() { }

  async openWordDocument(webUrl: string): Promise<void> {
    if (!webUrl) return;

    const deepLink = `ms-word:ofe|u|${webUrl}`;

    let backgroundAt: number | null = null;
    let listener = null;

    try {
      listener = await App.addListener('appStateChange', (state) => {
        if (!state.isActive) {
          backgroundAt = Date.now();
        }
      });

      window.location.href = deepLink;
    } catch (e) {
      console.error('Failed to open deep link:', e);
    }

    setTimeout(async () => {
      try {
        await listener?.remove();
      } catch (e) {
        console.error('Failed to remove appStateChange listener:', e);
      }

      if (backgroundAt && Date.now() - backgroundAt < this.APP_SWITCH_THRESHOLD) {
        return;
      }

      const platform = Capacitor.getPlatform();

      try {
        if (platform === 'android') {
          window.open(this.WORD_PLAY_STORE_URL, '_system');
        } else {
          await Browser.open({
            url: this.WORD_APP_STORE_URL
          });
        }
      } catch (e) {
        console.error('Failed to open app/play store:', e);
      }
    }, this.FALLBACK_DELAY);
  }
}
